<template>
  <div class="panel" v-for="data in movieByCategory"
    :key="data">
    <div class="category-title" :id="data[0].category"> {{ data[0].category }}</div>
    <div
      v-if="!device.isMobile"
      class="panel__grid">
      <div class="card"
        v-for="item in data"
        :key="item">
        <div class="card__img-block">
          {{ item.poster_url }}
          <img v-if="item?.poster || item?.poster_url" :src="`${item?.poster || item?.poster_url}?w=270&q=40`"
            :alt="item.title">
          <div v-else class="card__img-no">
            <font-awesome-icon icon="eye-slash" />
          </div>
        </div>
        <div class="card__img-hover">
          <img v-if="item?.poster || item?.poster_url" :src="`${item?.poster || item?.poster_url}?w=270&q=40`"
            :alt="item.title">
          <div v-else class="card__img-no">
            <font-awesome-icon icon="eye-slash" />
          </div>
          <MovieHoveringCard :item="item" :watching="watchingData" />
        </div>
        <div class="card__title">
          <h5>{{ item?.title[lang] || item?.title }}</h5>
        </div>
      </div>
    </div>
    <div
      v-else
      class="panel__grid">
      <div class="card"
        v-for="item in data"
        :key="item"
        @click="handleToMovie(item)">
        <div class="card__img-block">
          {{ item.poster_url }}
          <img v-if="item?.poster || item?.poster_url" :src="`${item?.poster || item?.poster_url}?w=270&q=40`"
            :alt="item.title">
          <div v-else class="card__img-no">
            <font-awesome-icon icon="eye-slash" />
          </div>
        </div>
        <div class="card__title">
          <h5>{{ item?.title[lang] || item?.title }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { ref, watch, defineProps, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router'
import MovieHoveringCard from '@/components/layouts/MovieHoveringCard.vue';
import { i18nRoute } from '@/utils/useTranslate';

const props = defineProps({
  movieByCategory: {
    type: Object,
  },
  minView: {
    type: Number,
    default: 8
  }
})

const store = useStore()
const route = useRoute()
const router = useRouter()
const minViewRef = ref(props.minView)
const lang = computed(() => store.state.language)
const watchingData = computed(() => store.state.media.watching.data)
const device = computed(() => store.state.device)

watch(() => route.query, () => minViewRef.value = props.minView)

const handleToMovie = (item) => {
  router.push(i18nRoute({ name: 'movie page', params: { id: item.slug } }))
}

</script>

<style lang="scss" scoped>
.category-title {
  font-weight: bold;
  font-size: 32px;
  margin-top: 32px;
  margin-bottom: 15px;

  @include media-breakpoint-down(xs) {
    font-size: rem(16);
  }
}

.panel {
  margin-bottom: rem(80);

  @include media-breakpoint-down(xs) {
    margin-bottom: rem(40);
  }
}
</style>
